export default __webpack_public_path__ + "static/media/first-mil.87bb24f7.png";